const ReportEvents = {
  TeamSoloReportViewed: "TeamSoloReportViewed",
  CustomTeamReportCreated: "CustomTeamReportCreated",
  CustomTeamReportChanged: "CustomTeamReportChanged",
  TeamViewpointsReportViewed: "TeamViewpointsReportViewed",
  CustomViewpointsReportCreated: "CustomViewpointsReportCreated",
  CustomViewpointsReportChanged: "CustomViewpointsReportChanged",
  SoloReportViewedForFirstTime: "SoloReportViewedForFirstTime",
  SoloReportViewed: "SoloReportViewed",
  ViewpointsReportViewedForFirstTime: "ViewpointsReportViewedForFirstTime",
  ViewpointsReportViewed: "ViewpointsReportViewed",
  ValuesReportViewedForFirstTime: "ValuesReportViewedForFirstTime",
  ValuesReportViewed: "ValuesReportViewed",
  SharedLinkReportAccessed: "SharedLinkReportAccessed",
};

export default function resolveReportLink(reportName: string): string {
  switch (reportName) {
    case ReportEvents.TeamSoloReportViewed:
    case ReportEvents.CustomTeamReportCreated:
    case ReportEvents.CustomTeamReportChanged:
      return "/teamreport/view/";
    case ReportEvents.TeamViewpointsReportViewed:
    case ReportEvents.CustomViewpointsReportCreated:
    case ReportEvents.CustomViewpointsReportChanged:
      return "/teamviewpointsreport/view/";
    case ReportEvents.SoloReportViewedForFirstTime:
    case ReportEvents.SoloReportViewed:
      return "/soloreport/view/";
    case ReportEvents.ViewpointsReportViewedForFirstTime:
    case ReportEvents.ViewpointsReportViewed:
      return "/viewpoints/view/";
    case ReportEvents.ValuesReportViewedForFirstTime:
    case ReportEvents.ValuesReportViewed:
      return "/customsolo/";
    case ReportEvents.SharedLinkReportAccessed:
      return "/sharedreport/";
    default:
      return "";
  }
}
